module.exports = __webpack_public_path__ + "static/media/room-3.38e936ac.jpeg";